import { BaseApi } from './base.api.js';

/**
 * Unified My Work API: combines PendingChange + Ticket + DocumentRevision
 * rows via a single server-side endpoint. Every row carries a `kind`
 * discriminator ('pendingChange' | 'ticket' | 'documentRevision' | 'workflowTask' |
 * 'workflowSubmission' | 'workflowInformed' | 'formTask' | 'operationalRunTask');
 * detail + actions are
 * dispatched by kind. The transport is identical for every kind — only the
 * server-side controller decides which model + state machine to advance.
 */
export class MyWorkApi extends BaseApi {
    constructor(client) {
        super(client, '/my-work');
    }

    async getMyPending(params = {}) {
        const response = await this.client.get(`${this.basePath}/my-pending`, { params });
        return response.data;
    }

    async getMySubmissions(params = {}) {
        const response = await this.client.get(`${this.basePath}/my-submissions`, { params });
        return response.data;
    }

    async getMyApprovalInvolvement(params = {}) {
        const response = await this.client.get(`${this.basePath}/my-approval-involvement`, { params });
        return response.data;
    }

    async getMyInformed(params = {}) {
        const response = await this.client.get(`${this.basePath}/my-informed`, { params });
        return response.data;
    }

    async getByKindAndId(kind, id) {
        const response = await this.client.get(`${this.basePath}/${kind}/${id}`);
        return response.data;
    }

    async approve(kind, id, data = {}) {
        const response = await this.client.post(`${this.basePath}/${kind}/${id}/approve`, data);
        return response.data;
    }

    async reject(kind, id, data = {}) {
        const response = await this.client.post(`${this.basePath}/${kind}/${id}/reject`, data);
        return response.data;
    }

    async returnToSubmitter(kind, id, data = {}) {
        const response = await this.client.post(`${this.basePath}/${kind}/${id}/return`, data);
        return response.data;
    }

    async markInformedRead(id) {
        const response = await this.client.post(`${this.basePath}/workflowInformed/${id}/read`);
        return response.data;
    }
}
